import { updateWeakAreas } from "./weakAreas";

const STORAGE_KEY = "cdl_quiz_history";
const MAX_SESSIONS = 100;

export function saveSession({ section, mode, questions, answers }) {
  console.log('💾 saveSession called:', { section, mode, questionsCount: questions.length, answersCount: Object.keys(answers).length });
  updateWeakAreas(questions, answers);
  const correct = questions.filter((q, i) => answers[i] === q.answer).length;
  const total = questions.length;
  const pct = Math.round((correct / total) * 100);
  console.log(`✅ Session saved: ${correct}/${total} (${pct}%)`);

  const session = {
    id: Date.now().toString(),
    section,
    mode,
    date: new Date().toISOString(),
    pct,
    correct,
    total,
    questions,
    answers,
  };

  const history = loadHistory();
  history.unshift(session); // newest first
  const trimmed = history.slice(0, MAX_SESSIONS);

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(trimmed));
  } catch {
    // Storage full — drop oldest sessions until it fits
    while (trimmed.length > 0) {
      trimmed.pop();
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(trimmed));
        break;
      } catch { /* keep trimming */ }
    }
  }

  return session;
}

export function loadHistory() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function deleteSession(id) {
  const updated = loadHistory().filter((s) => s.id !== id);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
}

export function clearHistory() {
  localStorage.removeItem(STORAGE_KEY);
}

export function formatDate(isoString) {
  const d = new Date(isoString);
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

export function formatTime(isoString) {
  const d = new Date(isoString);
  return d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", hour12: true });
}

export function formatRelative(isoString) {
  const diff = Date.now() - new Date(isoString).getTime();
  const mins  = Math.floor(diff / 60000);
  const hours = Math.floor(diff / 3600000);
  const days  = Math.floor(diff / 86400000);
  if (mins  < 1)   return "just now";
  if (mins  < 60)  return `${mins}m ago`;
  if (hours < 24)  return `${hours}h ago`;
  if (days  < 7)   return `${days}d ago`;
  return formatDate(isoString);
}
